<template lang="pug">
  .create-plan_rate-reservation-rates
    ModalReveal(ref="revealPlanCreate")
      .button.button(slot="trigger" ) Add for {{bookingMode}}
      h2 Plan reservation rate for {{bookingMode}}
      .row
        .columns
          label Name
            input(type="text", v-model="plan_rate.name")
          label Vehicle Category
            selectize-category(@optionSelected="selectCategory")
        .column
          label Reservation rate
            selectize-reservation-rate(@optionSelected="selectRate")
          label Disabled
            input(type="checkbox", v-model="plan_rate.disabled")
      .row
        .columns.text-right
          ActionButton(:action="savePlanRate") Save
</template>
<script type="text/babel">

import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
import PlanReservationRate from "../PlanReservationRate.vue";
import SelectizeCategory from "../../structure/ui/lists/selectize/SelectizeCategory";
import SelectizeReservationRate from "../../structure/ui/lists/selectize/SelectizeReservationRate";
import DatePicker from "../../structure/DatePicker";
import MaggieHelper from "../../../maggieHelper";
import BookingModeSelect from "../../structure/BookingModeSelect";
import ModalReveal from "../../structure/foundation/ModalReveal.vue";
import ActionButton from "../../structure/ui/ActionButton.vue";


export default {
  name: "CreatePlanReservationRates",
  components: {
    ActionButton,
    ModalReveal,
    BookingModeSelect, DatePicker, SelectizeReservationRate, SelectizeCategory, PlanReservationRate
  },
  data() {
    return {
      plan_rate: {
        name: null,
        vehicle_category_id: null,
        plan_id: null,
        reservation_rate_id: null,
        booking_mode: null,
        time_resolution_method: "ITWILLBEDEADSOON",
        time_resolution_cycle: 0,
        distance_resolution_method: "ITWILLBEDEADSOON",
        distance_resolution_cycle: 0,
        valid_from: null,
        valid_to: null,
        disabled: false,
      },
      booking_modes: []
    }
  },
  created() {

  },
  methods: {
    selectCategory(item) {
      this.plan_rate.vehicle_category_id = item.id
    },
    selectRate(item) {
      this.plan_rate.reservation_rate_id = item.id
    },
    savePlanRate() {
      this.plan_rate.booking_mode = this.bookingMode
      this.plan_rate.plan_id = this.planId

      return KeplerBackofficeSdk.planReservationRates.make(this.plan_rate, (data) => {
        MaggieHelper.notification('rate', 'Reservation rate created')
        this.$emit('added')
        this.$refs.revealPlanCreate.close()
      })
    }
  },
  computed: {},
  props: {
    planId: {},
    bookingMode: {},
  },
}
</script>
<style lang="sass" rel="stylesheet/sass">
.create-plan_rate-reservation-rates
  background: white

</style>



// WEBPACK FOOTER //
// CreatePlanReservationRates.vue?3007bade